import React from 'react';
import StatCard from '../components/dashboard/StatCard';
import ChartCard from '../components/dashboard/ChartCard';
import { Users, DollarSign, BarChart2, MessageSquare, Link, Clock, AlertTriangle } from 'lucide-react';
import { userGrowthData, userActivityData, revenueData, featureUsageData, systemPerformanceData } from '../utils/mockData';
const Dashboard: React.FC = () => {
  return <div className="space-y-6" data-id="element-1254">
      <div data-id="element-1255">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-1256">
          Dashboard Overview
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-1257">
          Welcome to the Fintrove admin dashboard. Here's an overview of your
          platform.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1258">
        <StatCard title="Total Users" value="12,543" change={8.2} icon={<Users size={24} data-id="element-1260" />} iconBg="bg-blue-600" description="Total registered users" data-id="element-1259" />
        <StatCard title="Active Today" value="1,853" change={4.5} icon={<Users size={24} data-id="element-1262" />} iconBg="bg-green-600" description="Users active in the last 24 hours" data-id="element-1261" />
        <StatCard title="Monthly Revenue" value="$45,621" change={12.3} icon={<DollarSign size={24} data-id="element-1264" />} iconBg="bg-purple-600" description="Revenue from subscriptions and referrals" data-id="element-1263" />
        <StatCard title="Connected Banks" value="32" change={0} icon={<Link size={24} data-id="element-1266" />} iconBg="bg-indigo-600" description="Active bank integrations" data-id="element-1265" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1267">
        <ChartCard title="User Growth" subtitle="New user registrations over time" data={userGrowthData} type="line" dataKeys={['users']} colors={['#3B82F6']} data-id="element-1268" />
        <ChartCard title="Daily Active Users" subtitle="Active and new users by day" data={userActivityData} type="bar" dataKeys={['active', 'new']} colors={['#10B981', '#F59E0B']} data-id="element-1269" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1270">
        <ChartCard title="Revenue Breakdown" subtitle="Monthly revenue by source" data={revenueData} type="bar" dataKeys={['premium', 'referrals']} colors={['#8B5CF6', '#EC4899']} data-id="element-1271" />
        <ChartCard title="Feature Usage" subtitle="Percentage of users using each feature" data={featureUsageData} type="bar" dataKeys={['usage']} colors={['#3B82F6']} data-id="element-1272" />
      </div>
      <div className="grid grid-cols-1 gap-6" data-id="element-1273">
        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6" data-id="element-1274">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-1275">
            System Status
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1276">
            <div className="flex items-center" data-id="element-1277">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-green-100 dark:bg-green-900 text-green-600 dark:text-green-200" data-id="element-1278">
                <Clock size={24} data-id="element-1279" />
              </div>
              <div className="ml-4" data-id="element-1280">
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1281">
                  Avg Response Time
                </p>
                <p className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-1282">
                  142ms
                </p>
              </div>
            </div>
            <div className="flex items-center" data-id="element-1283">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-yellow-100 dark:bg-yellow-900 text-yellow-600 dark:text-yellow-200" data-id="element-1284">
                <AlertTriangle size={24} data-id="element-1285" />
              </div>
              <div className="ml-4" data-id="element-1286">
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1287">
                  Error Rate
                </p>
                <p className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-1288">
                  0.08%
                </p>
              </div>
            </div>
            <div className="flex items-center" data-id="element-1289">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-200" data-id="element-1290">
                <BarChart2 size={24} data-id="element-1291" />
              </div>
              <div className="ml-4" data-id="element-1292">
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1293">
                  API Calls
                </p>
                <p className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-1294">
                  1.2M today
                </p>
              </div>
            </div>
          </div>
          <div className="mt-6" data-id="element-1295">
            <ChartCard title="System Performance" subtitle="Response time and errors over the last 24 hours" data={systemPerformanceData} type="line" dataKeys={['responseTime', 'errors']} colors={['#3B82F6', '#EF4444']} data-id="element-1296" />
          </div>
        </div>
      </div>
    </div>;
};
export default Dashboard;